<article>
  <header (click)="handleToggleAccordion()">
    <strong>Filtro</strong>
    <img
      class="accordion-img"
      [ngClass]="{ 'rotate-animation': !isOpen }"
      src="assets/icons/arrow.svg"
    />
  </header>
  <main [ngClass]="{ 'is-collapsed': !isOpen }">
    <div main class="main">
      <div class="grid-content">
        <div class="period">
          <div class="period-input">
            <app-input
              label="Período"
              placeholder="De"
              [control]="form.controls.initialDate"
              [disabled]="false"
              [type]="InputTypeEnum.date"
            ></app-input>
            <app-input
              label=""
              placeholder="Até"
              [control]="form.controls.finalDate"
              [disabled]="false"
              [type]="InputTypeEnum.date"
            ></app-input>
          </div>
        </div>

        <app-select-multi
          label="Clientes"
          placeholder="Selecione múltiplos clientes"
          [multiControl]="form.controls.clients"
          [selected]="selectedClients"
          [options]="clients"
          [multi]="true"
          [disabled]="loadingClients"
          [loading]="loadingClients"
          (searchValueEmmiter)="getClients($event)"
          [isPaged]="true"
          [isSearch]="true"
          [isDinamicSearch]="true"
          [loadingSearch]="loadingSearchClients"
          [loadingPage]="loadingMoreClients"
          (scrollEndedEmmiter)="getMoreClients()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Skills"
          placeholder="Selecione múltiplas skills"
          [multiControl]="form.controls.skills"
          [selected]="selectedSkills"
          [options]="skills"
          [multi]="true"
          [disabled]="loadingSkills"
          [loading]="loadingSkills"
          (searchValueEmmiter)="getSkills()"
          [isPaged]="true"
          [loadingPage]="loadingMoreSkills"
          (scrollEndedEmmiter)="getMoreSkills()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Células"
          placeholder="Selecione múltiplas células"
          [multiControl]="form.controls.cells"
          [selected]="selectedCells"
          [options]="cells"
          [multi]="true"
          [disabled]="loadingCells"
          [loading]="loadingCells"
          (searchValueEmmiter)="getCells()"
          [isPaged]="true"
          [loadingPage]="loadingMoreCells"
          (scrollEndedEmmiter)="getMoreCells()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Sub-células"
          placeholder="Selecione múltiplas sub-células"
          [multiControl]="form.controls.subCells"
          [selected]="selectedSubCells"
          [options]="subCells"
          [multi]="true"
          [disabled]="loadingSubcells"
          [loading]="loadingSubcells"
          (searchValueEmmiter)="getSubCells()"
          [isPaged]="true"
          [loadingPage]="loadingMoreSubCells"
          (scrollEndedEmmiter)="getMoreSubCells()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Supervisores"
          placeholder="Selecione múltiplos supervisores"
          [multiControl]="form.controls.supervisors"
          [selected]="selectedSupervisors"
          [options]="supervisors"
          [multi]="true"
          [disabled]="loadingSupervisors"
          [loading]="loadingSupervisors"
          (searchValueEmmiter)="getSupervisors($event)"
          [isPaged]="true"
          [isSearch]="true"
          [isDinamicSearch]="true"
          [loadingSearch]="loadingSearchSupervisors"
          [loadingPage]="loadingMoreSupervisors"
          (scrollEndedEmmiter)="getMoreSupervisors()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Atendentes"
          placeholder="Selecione múltiplos atendentes"
          [multiControl]="form.controls.attendants"
          [selected]="selectedAttendants"
          [options]="attendants"
          [multi]="true"
          [disabled]="loadingAttendants"
          [loading]="loadingAttendants"
          (searchValueEmmiter)="getAttendants($event)"
          [isPaged]="true"
          [isSearch]="true"
          [isDinamicSearch]="true"
          [loadingSearch]="loadingSearchAttendants"
          [loadingPage]="loadingMoreAttendants"
          (scrollEndedEmmiter)="getMoreAttendants()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Turnos"
          placeholder="Selecione múltiplos turnos"
          [multiControl]="form.controls.shifts"
          [options]="shifts"
          [selected]="selectedShifts"
          property="Type"
          [disabled]="loadingShifts"
          [multi]="true"
          [loading]="loadingShifts"
        ></app-select-multi>

        <app-select-multi
          label="Tipos"
          placeholder="Selecione múltiplos tipos"
          [multiControl]="form.controls.types"
          [options]="types"
          [selected]="selectedTypes"
          property="Type"
          [disabled]="false"
          [multi]="true"
        ></app-select-multi>

        <app-select-multi
          label="Motivo de Contato (Macro)"
          placeholder="Selecione múltiplas opções"
          [multiControl]="form.controls.macroContactReasons"
          [selected]="selectedMacroContactReason"
          [options]="macroContactReasonsOptions"
          [multi]="true"
          [disabled]="loadingContactReasons"
          [loading]="loadingContactReasons"
          (searchValueEmmiter)="getContactReasons()"
          [isPaged]="true"
          [loadingPage]="loadingMoreContactReasons"
          (scrollEndedEmmiter)="getMoreContactReasons()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Motivo de Contato (Micro)"
          placeholder="Selecione múltiplas opções"
          [multiControl]="form.controls.microContactReasons"
          [selected]="selectedMicroContactReason"
          [options]="microContactReasonsOptions"
          [multi]="true"
          [disabled]="loadingContactReasons"
          [loading]="loadingContactReasons"
          (searchValueEmmiter)="getContactReasons()"
          [isPaged]="true"
          [isSearch]="true"
          [isDinamicSearch]="true"
          [loadingSearch]="loadingSearchContactReasons"
          [loadingPage]="loadingMoreContactReasons"
          (scrollEndedEmmiter)="getMoreContactReasons()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>
      </div>
    </div>
    <hr />
    <div footer class="footer">
      <app-secondary-button
        label="Limpar"
        [color]="ButtonColorEnum.warning"
        [icon]="'assets/icons/trash.svg'"
        [enabled]="true"
        [widthFull]="true"
        (clickFunc)="clear()"
      >
      </app-secondary-button>
      <app-primary-button
        [label]="'Aplicar Filtros'"
        [color]="ButtonColorEnum.common"
        [loading]="isLoading"
        [enabled]="true"
        (clickFunc)="filter()"
      ></app-primary-button>
    </div>
  </main>
</article>
